import { translate } from '@utils/i18n';
import LinkTableCell from '@components/Kendo/LinkTableCell';
import { buildInitialState as buildInitialDateRangeState } from '@components/Kendo/DateRangePickerReducer';
import ActionsCell from './nested/ActionsCell';
import DetailsCell from './nested/DetailsCell';
import PhotosCell from './nested/PhotosCell';

export const CACHE_KEY = 'kendo/deficiencies/index';

export const NAMESPACE = 'features.deficiencies_index';

export const INITIAL_PAGE_SKIP = 0;

export const INITIAL_PAGE = { skip: INITIAL_PAGE_SKIP, take: 25 };

export const INITIAL_SORT = [
  {
    field: 'inspection',
    dir: 'desc'
  }
];

export const INITIAL_FILTERS = {
  values: {
    resolved: '',
    building: '',
    territory: '',
    additionalTerritory: '',
    account: '',
    type: '',
    resolutionStatus: '',
    technician: null,
    deficiencyStatus: '',
    salesPerson: '',
    assets: '',
    workOrder: '',
    inspectionId: '',
    deficiencyId: '',
    ...buildInitialDateRangeState('dateOpened'),
    ...buildInitialDateRangeState('lastReportedOn')
  },
  active: {
    resolved: true,
    building: true,
    territory: false,
    additionalTerritory: false,
    account: false,
    type: true,
    resolutionStatus: true,
    technician: false,
    deficiencyStatus: true,
    salesPerson: false,
    dateOpened: true,
    lastReportedOn: true,
    assets: true,
    inspectionId: false,
    deficiencyId: false
  },
  operators: {
    inspectionId: 'contains',
    deficiencyId: 'contains'
  }
};

export const ALL_COLUMNS = [
  'id',
  'inspection',
  'inspectionDate',
  'building',
  'account',
  'dateOpened',
  'lastReportedOn',
  'resolved',
  'systemAsset',
  'details',
  'deficiencyStatus',
  'resolutionStatus',
  'resolutionNotes',
  'notes',
  'internalNotes',
  'resolvedBy',
  'n_of_photos',
  'actions'
];

export const ALL_COLUMNS_DATA = {
  selected: {
    id: 'selected',
    field: 'selected',
    sortable: false,
    title: translate('table.headers.selected', { namespace: NAMESPACE }),
    className: 'k-table-td --selector',
    width: 50,
    headerClassName: 'k-table-th --selector'
  },
  id: {
    id: 'id',
    field: 'id',
    title: translate('table.headers.id', { namespace: NAMESPACE }),
    width: 130,
    cell: LinkTableCell
  },
  inspection: {
    id: 'inspection',
    field: 'inspection',
    title: translate('table.headers.inspection', { namespace: NAMESPACE }),
    width: 130,
    cell: LinkTableCell
  },
  building: {
    id: 'building',
    field: 'building',
    title: translate('table.headers.building', { namespace: NAMESPACE }),
    width: 250,
    cell: LinkTableCell
  },
  account: {
    id: 'account',
    field: 'account',
    title: translate('table.headers.account', { namespace: NAMESPACE }),
    width: 150,
    cell: LinkTableCell
  },
  dateOpened: {
    id: 'dateOpened',
    field: 'dateOpened',
    width: 130,
    title: translate('table.headers.date_opened', { namespace: NAMESPACE })
  },
  lastReportedOn: {
    id: 'lastReportedOn',
    field: 'lastReportedOn',
    width: 150,
    title: translate('table.headers.last_reported_on', { namespace: NAMESPACE })
  },
  resolved: {
    id: 'resolved',
    field: 'resolved',
    title: translate('table.headers.resolved', { namespace: NAMESPACE }),
    width: 130,
    sortable: false
  },
  systemAsset: {
    id: 'systemAsset',
    field: 'systemAsset',
    title: translate('table.headers.system_asset', { namespace: NAMESPACE }),
    width: 140,
    sortable: false
  },
  details: {
    id: 'details',
    field: 'details',
    title: translate('table.headers.details', { namespace: NAMESPACE }),
    width: 200,
    sortable: false,
    cell: DetailsCell
  },
  deficiencyStatus: {
    id: 'deficiencyStatus',
    field: 'deficiencyStatus',
    width: 130,
    title: translate('table.headers.deficiency_status', { namespace: NAMESPACE })
  },
  resolutionStatus: {
    id: 'resolutionStatus',
    field: 'resolutionStatus',
    width: 130,
    title: translate('table.headers.resolution_status', { namespace: NAMESPACE })
  },
  resolutionNotes: {
    id: 'resolutionNotes',
    field: 'resolutionNotes',
    title: translate('table.headers.resolution_notes', { namespace: NAMESPACE }),
    width: 150,
    sortable: false,
    className: 'cell-multiline'
  },
  notes: {
    id: 'notes',
    field: 'notes',
    title: translate('table.headers.notes', { namespace: NAMESPACE }),
    width: 150,
    sortable: false,
    className: 'cell-multiline'
  },
  internalNotes: {
    id: 'internalNotes',
    field: 'internalNotes',
    title: translate('table.headers.internal_notes', { namespace: NAMESPACE }),
    width: 150,
    sortable: false,
    className: 'cell-multiline'
  },
  inspectionDate: {
    id: 'inspectionDate',
    field: 'inspectionDate',
    width: 130,
    title: translate('table.headers.inspection_date', { namespace: NAMESPACE })
  },
  resolvedBy: {
    id: 'resolvedBy',
    field: 'resolvedBy',
    width: 150,
    title: translate('table.headers.resolved_by', { namespace: NAMESPACE })
  },
  n_of_photos: {
    id: 'n_of_photos',
    field: 'n_of_photos',
    width: 130,
    title: translate('table.headers.n_of_photos', { namespace: NAMESPACE }),
    cell: PhotosCell,
    sortable: false
  },
  actions: {
    id: 'actions',
    field: 'actions',
    title: translate('table.headers.actions', { namespace: NAMESPACE }),
    sortable: false,
    width: 130,
    cell: ActionsCell
  }
};
